import { useState, useCallback, createContext, useContext } from 'react';

interface RoutePreloaderContextType {
  handleMouseEnter: (route: string) => void;
  handleFocus: (route: string) => void;
}

const RoutePreloaderContext = createContext<RoutePreloaderContextType>({
  handleMouseEnter: () => {},
  handleFocus: () => {}
});

export function RoutePreloaderProvider({ children }: { children: React.ReactNode }) {
  const [preloadedRoutes] = useState(new Set<string>());

  const preloadRoute = useCallback((route: string) => {
    if (preloadedRoutes.has(route)) return;

    // Aqui você pode adicionar lógica para pré-carregar rotas
    // Por exemplo, usando dynamic imports
    switch (route) {
      case 'Dashboard':
        import('@/pages/Dashboard').catch(console.error);
        break;
      case 'Planning':
        import('@/pages/Planning').catch(console.error);
        break;
      case 'Records':
        import('@/pages/Records').catch(console.error);
        break;
      case 'PiggyBanks':
        import('@/pages/PiggyBanks').catch(console.error);
        break;
      case 'Settings':
        import('@/pages/Settings').catch(console.error);
        break;
      case 'AddIncome':
        import('@/pages/AddIncome').catch(console.error);
        break;
      case 'AddExpense':
        import('@/pages/AddExpense').catch(console.error);
        break;
      case 'Reports':
        import('@/pages/Reports').catch(console.error);
        break;
      case 'Tracking':
        import('@/pages/Tracking').catch(console.error);
        break;
      default:
        break;
    }

    preloadedRoutes.add(route);
  }, [preloadedRoutes]);

  const handleMouseEnter = useCallback((route: string) => {
    preloadRoute(route);
  }, [preloadRoute]);

  const handleFocus = useCallback((route: string) => {
    preloadRoute(route);
  }, [preloadRoute]);

  return (
    <RoutePreloaderContext.Provider value={{ handleMouseEnter, handleFocus }}>
      {children}
    </RoutePreloaderContext.Provider>
  );
}

export function useRoutePreloader() {
  return useContext(RoutePreloaderContext);
}
